import { Injectable } from '@angular/core';
import { CurrentProject } from '@shared/model/currentProject.model';

import { BaseSignalStore } from '../signal-state.util';

export interface CurrentProjectState {
  data: Partial<CurrentProject> | any;
}

function createInitialState(): CurrentProjectState {
  return { data: {} };
}

@Injectable({ providedIn: 'root' })
export class CurrentProjectStore extends BaseSignalStore<CurrentProjectState> {
  constructor() {
    super(createInitialState(), { name: 'current_project_store' });
  }
}
